<SearchableList
    searchLabel={lang.main('Search_for_groups')}
    searchPlaceholder={lang.main('Search_for_groups')}
    bind:selectedIds
    bind:selectedTitle
    {pageSizesList}
    {getItemsFn}
    {selectedTitles}
    getNameFn={item => item.title}
    searchEmptyTitle={lang.main("No_results")}
    searchEmptyDescription={lang.main("Course_groups_No_groups_found_search_result")}
    emptyTitle={lang.main("No_groups")}
    emptyDescription={lang.main("There_are_no_groups_in_this_course")}
    emptyStateIcon="user-groups"
    emptyStateLinkText={lang.main("Create_group")}
    {emptyStateLinkUrl}
    on:error
>
    <ParticipantGroupHeader slot="headerTemplate" />
    <ParticipantGroupRow slot="rowTemplate" let:item item={item} />
</SearchableList>

<script lang="ts">
    import { onMount } from "svelte";
    import { lang } from "@its-ui/mono/lang/provider";

    import SearchableList from "../SearchableList.svelte";
    import ParticipantGroupHeader from './ParticipantGroupHeader.svelte';
    import ParticipantGroupRow from './ParticipantGroupRow.svelte';
    import type {
        GetItemsFn,
        GetParticipantGroupsFn
    } from "../../courseParticipantsDataProvider";

    export let selectedGroupIds: number[];
    export let getGroupsFn: GetParticipantGroupsFn;
    export let emptyStateLinkUrl: string;
    export let selectedTitles: Map<number, string>;
    export let selectedTitle: string;
    export let pageSizesList: number[];

    let selectedIds: number[] = [];

    async function getItemsFn(pageIndex: number, pageSize: number, searchText?: string): Promise<GetItemsFn> {
        const response = await getGroupsFn(pageIndex, pageSize, searchText);
        return {
            totalCount: response.totalCount,
            items: response.groups.map(p => ({
                id: p.groupId,
                value: p
            }))
        };
    }

    onMount(() => {
        selectedIds = selectedGroupIds ? [ ...selectedGroupIds ] : [];
    });

    export function getSelectedValues() {
        return { selectedIds, selectedTitle }
    }
</script>